import React from 'react';
import { ClockIcon, GlobeIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const isDark = tone === 'dark';
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="mx-auto mt-8 w-full max-w-md text-center" role="timer" aria-live="off" data-id="element-50" data-mp="3c3z0qx1goybr">
      <p className={`flex items-center justify-center gap-2 font-display text-lg font-bold uppercase tracking-wide ${isDark ? 'text-gold-400' : 'text-alert-600'}`} data-id="element-51" data-mp="3gyw5hrrpkliu">
        <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-52" data-mp="374vtd5y0eg0m" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-53" data-mp="10a8wwfjcac1m">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-54" data-mp="1592984mw3x07" data-mpi={i}>
            <div className={`flex w-[84px] flex-col items-center rounded-xl py-2.5 ${isDark ? 'bg-white text-ink' : 'bg-navy-900 text-white'}`} data-id="element-55" data-mp="y0endtowvxxs">
              <span className="font-display text-[44px] font-extrabold leading-none tabular-nums" data-id="element-56" data-mp="17py8l603k3vt">{u.value}</span>
              <span className={`mt-1 text-[11px] font-semibold uppercase tracking-wider ${isDark ? 'text-muted' : 'text-slate-300'}`} data-id="element-57" data-mp="12t7rqgggx49c">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`font-display text-4xl font-extrabold ${isDark ? 'text-white' : 'text-navy-900'}`} aria-hidden="true" data-id="element-58" data-mp="o4k2erx7tqru">
                :
              </span>}
          </React.Fragment>)}
      </div>
      <p className="mt-4 inline-flex items-center rounded-full bg-alert-600 px-4 py-1.5 font-display text-base font-bold uppercase tracking-wider text-white" data-id="element-59" data-mp="1vfiu9wnmxf8s">
        Limited launch offer
      </p>
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-[13px] ${isDark ? 'text-slate-300' : 'text-muted'}`} data-id="element-60" data-mp="x3on9fpz9fjy">
        <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="165fp29hed28j" />
        Automatic currency conversion based on your country.
      </p>
    </div>;
}